import { Paso } from './Paso';

export class PasoDisco extends Paso {
  constructor() {
    super(
      false,
      'Almacenamiento',
      `Acá es donde se guardarán tus documentos. Se debe tener en cuenta el tamaño y la velocidad. Las unidades SSD son más veloces y pueden ser utilizadas
      como unidad principal de almacenamiento o como un complemento de un almacenamiento HDD.`,
      6,
      'hdd.png',
      'hdd.png',
      true,
      [
        {
          nombre: 'Sólido',
          svg: 'ssd',
          filtro: {
            campo: 'tipo_almacenamiento',
            valor: ['Sólido'],
          },
        },
        {
          nombre: 'Rígido',
          svg: 'hdd',
          filtro: {
            campo: 'tipo_almacenamiento',
            valor: ['Mecánico'],
          },
        },
        {
          nombre: 'Todos',
          icono: '',
          filtro: {
            campo: 'tipo_almacenamiento',
            valor: ['Sólido', 'Mecánico'],
          },
        },
      ],
      '',
    );
  }
}
